var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("internal-bill-info", {
    ref: "internalBillInfo",
    attrs: {
      context: _vm.context,
      action: _vm.action,
      location: _vm.location,
      "enable-ui-custom": _vm.enableUiCustom,
      "page-type": _vm.pageType
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }